import {createContext} from 'react'

export const BranchServiceStepContext = createContext({
  modalOpen: false,
  setModalOpen: () => {
  },
  gridRowCount: 0,
  setGridRowCount: () => {
  },
  gridCurrentPage: 1,
  setGridCurrentPage: () => {
  },
  branchServiceStep: {
    id: null,
    branch_id: null,
    title: "",
    description: "",
    step: "",
    status: "enable",
    admin_id: null,
  },
  setBranchServiceStep: () => {
  },
  lastDataRefresh: Date.now(),
  setLastDataRefresh: () => {
  },
})